import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Accordion from 'src/components/atoms/Accordion';
import AccordionSitemapEvaluation from 'src/components/molecules/AccordionSitemapEvaluation';
import {
  useBaseUrlStore,
  useLabels,
  useLanguageStore,
} from 'src/StoreDataProvider';

const Sitemap: () => JSX.Element = () => {
  const labels = useLabels();
  const navigate = useNavigate();
  const { path, isYearView } = useBaseUrlStore();
  const { language } = useLanguageStore();

  useEffect(() => {
    document.title = `${
      isYearView ? labels.titleYearsView1 : labels.titleDefaultView1
    } - Sitemap`;
  }, [language, isYearView, labels.titleYearsView1]);

  return (
    <div className="sitemap__container">
      <h1 className="sitemap__titles mobileTitle outerTitle">
        {labels.tableOfContents}
      </h1>
      <div className="sitemap-container project-tile">
        <h2 className="sitemap__titles innerTitle">{labels.aboutIDEaLApp}</h2>
        <ul className="sitemap-container__parentAccordions">
          <li className="sitemap-container__list">
            <Accordion
              title={labels.homePage}
              isActive={false}
              hierachy={3}
              onClick={() => navigate(`/${path}`)}
            />
          </li>
          <li className="sitemap-container__list">
            <AccordionSitemapEvaluation />
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Sitemap;
